// extracted by mini-css-extract-plugin
export default {"warning":"f3yj9"};